<script setup lang="ts">
import type { FavoriteItem } from "~/types";
import useSekouFavorite from "~/composables/useSekouFavorite";
import usePlanFavorite from "~/composables/usePlanFavorite";
interface Props {
  item: FavoriteItem;
}
const props = defineProps<Props>();
const { toggleSekou, favoriteSekou } = useSekouFavorite();
const { togglePlan, favoritePlan } = usePlanFavorite();

const isActive = computed(() => {
  if (props.item.type == "plan") {
    return favoritePlan.value.some((e) => e.cd == props.item.cd);
  }
  return favoriteSekou.value.some(
    (e) => e.cd == props.item.cd && e.num == props.item.num,
  );
});
</script>

<template>
  <div :class="isActive ? 'activate' : 'inactive'">
    <button
      :class="
        isActive
          ? 'text-red-600 hover:text-red-500'
          : 'text-gray-400 hover:text-gray-500'
      "
      aria-label="お気に入りボタン"
      class="relative drop-shadow"
      @click="item.type == 'plan' ? togglePlan(item) : toggleSekou(item)"
    >
      <Icon class="stroke-white" size="48" name="mdi:heart" />
    </button>
  </div>
</template>
<style scoped lang="scss">
.activate {
  animation: activate 0.2s ease both;
  transform: scale(1);
}

@keyframes activate {
  0%,
  10% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(1.2);
  }
}

.inactive {
  animation: inactive 0.2s ease;
  transform: scale(1);
}

@keyframes inactive {
  50% {
    transform: scale(0.8);
  }
}
</style>
